// Notification read/dismiss/preferences endpoints.
import { z } from 'zod';

import { NOTIFICATION_CATEGORIES, NOTIFICATION_CHANNELS } from '../notifications/categories.js';
import { idSchema } from './common.js';

export const markNotificationReadInputSchema = z.object({
  notification_id: idSchema,
});
export type MarkNotificationReadInput = z.infer<typeof markNotificationReadInputSchema>;

export const markManyNotificationsReadInputSchema = z.object({
  notification_ids: z.array(idSchema).min(1).max(100),
});
export type MarkManyNotificationsReadInput = z.infer<
  typeof markManyNotificationsReadInputSchema
>;

export const dismissAllNotificationsInputSchema = z.object({
  before: z.string().datetime({ offset: true }).optional(),
});
export type DismissAllNotificationsInput = z.infer<typeof dismissAllNotificationsInputSchema>;

export const updateNotificationPreferenceInputSchema = z.object({
  category: z.enum(NOTIFICATION_CATEGORIES),
  channel: z.enum(NOTIFICATION_CHANNELS),
  enabled: z.boolean(),
});
export type UpdateNotificationPreferenceInput = z.infer<
  typeof updateNotificationPreferenceInputSchema
>;

export const updateNotificationPreferencesBulkInputSchema = z.object({
  preferences: z
    .array(
      z.object({
        category: z.enum(NOTIFICATION_CATEGORIES),
        channel: z.enum(NOTIFICATION_CHANNELS),
        enabled: z.boolean(),
      }),
    )
    .min(1)
    .max(NOTIFICATION_CATEGORIES.length * NOTIFICATION_CHANNELS.length),
});
export type UpdateNotificationPreferencesBulkInput = z.infer<
  typeof updateNotificationPreferencesBulkInputSchema
>;
